import Master from "./Master";

const PointOfServiceDelivery = (props) => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const submitUrl = apiEndPoint + "/PoSD/";
  const parentSource = apiEndPoint + "/PoSDForSelect/";
  const getAllUrl = apiEndPoint + "/PoSDAll/";
  const lobSource = apiEndPoint + "/LoBForSelect/";
  const deleteUrl = apiEndPoint + "/PoSD/";

  const masterProps = {
    masterlabel: "Point of Service Delivery",
    id: "posd-master",
    variant: "primary",
    submitUrl: submitUrl,
    getAllUrl: getAllUrl,
    deleteUrl: deleteUrl,
    primaryKey: "point_of_service_delivery_id",
    newEntryForm: props?.newEntryForm === undefined ? true : props.newEntryForm,
    fields: [
      {
        label: "Name",
        props: { required: true },
        ref: "point_of_service_delivery_name",
      },
      {
        label: "Parent",
        controlType: "select",
        props: { required: true },
        defaultLabel: "Select Parent PoSD",
        options: [
          {
            label: "Root",
            value: 0,
          },
        ],
        dataUrl: parentSource,
        ref: "parent_point_of_service_delivery_id",
        tableValue: "parent_point_of_service_delivery_name",
      },
      {
        label: "Line of Business",
        controlType: "select",
        props: { required: true },
        defaultLabel: "Select LoB",
        dataUrl: lobSource,
        ref: "lob_id",
        tableValue: "lob_name",
      },
    ],
  };
  return <Master {...masterProps} />;
};
export default PointOfServiceDelivery;
